import React from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Button } from "@otp/ui";
import { HomeContained } from "@otp/icons";
import { Link } from "src/components/common/link";
import { Routes } from "src/components/common/router/constants";

import styles from "./item.module.css";

export const ViewDetailsButton = ({ storeId }: { storeId: string }) => {
  const { t } = useTranslation();

  return (
    <Link to={`${Routes.restaurants.path}/${storeId}`}>
      <Button variant="outlined" size="small">
        <HomeContained
          className={clsx(
            styles.viewDetailsButtonIcon,
            "scale-75 relative -left-1",
          )}
        />{" "}
        {t("manage-restaurants.view-details")}
      </Button>
    </Link>
  );
};
